export const defaultRoute = "/";

export const routes = {
  imageEditor: "/editor"
};
